export default __webpack_public_path__ + "static/media/mongoDB.6c6da702.svg";